import Quill from 'quill'
import { Subject } from 'rxjs'

export class Tooltip extends Quill.import('ui/tooltip') {
  static TEMPLATE = '<input type="text"><a class="ql-action"></a>'

  save$ = new Subject()

  constructor(quill: typeof Quill) {
    super(quill)

    this.textbox = this.root.querySelector('input[type="text"]')
    this.listen()
  }

  listen = (): void => {
    if (this.textbox) {
      this.textbox.addEventListener('keydown', (event: Event) => {
        const keyboard = this.quill.getModule('keyboard').constructor

        if (keyboard.match(event, 'enter')) {
          this.save()

          event.preventDefault()
        }

        if (keyboard.match(event, 'escape')) {
          this.cancel()

          event.preventDefault()
        }
      })
    }

    const button = this.root.querySelector('a.ql-action')

    if (button) {
      button.addEventListener('click', (event: Event) => {
        if (this.root.classList.contains('ql-editing')) this.save()

        event.preventDefault()
      })
    }

    this.quill.on('selection-change', (range: null) => {
      if (range === null) return

      this.hide()
    })
  }

  cancel = (): void => {
    this.hide()
  }

  save = (): void => {
    if (!this.textbox) return

    const value = this.textbox.value

    this.save$.next(value)
    this.hide()
  }

  edit = (mode: string): void => {
    if (!this.textbox) return

    this.root.classList.remove('ql-hidden')
    this.root.classList.add('ql-editing')
    this.textbox.value = ''
    this.position(this.quill.getBounds(this.quill.selection.savedRange))
    this.textbox.select()
    this.textbox.setAttribute('placeholder', this.textbox.getAttribute(`data-${mode}`) || '')
    this.root.setAttribute('data-mode', mode)
  }
}
